import React from 'react';
import { Button } from '../Button/Button';

import meditate from '../../images/meditate.png';
import arrow from '../../images/arrow-curly.svg';
import './CTA.scss';

const CTA = () => (
  <div className="cta container text-center">
    <img src={meditate} alt="" />
    <div className="wrap">
      <h1 className="title text-gradient">Declutter, prioritize, zone-in.</h1>
      <h1>Repeat.</h1>
      <img className="arrow" src={arrow} alt="" />
    </div>
    <Button text="Get started with Aerotime" size="lg" type="primary" />
  </div>
);

export default CTA;
